import "preline";
import { HSTooltip, HSDropdown } from "preline";

// Need to import ClipboardJS from the window object so that helpers can use it
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// HSTooltip must be on window for the clipboard helper's success callback
window.HSTooltip = HSTooltip;

// HSDropdown must be on window for inline onclick handlers (e.g. closeCurrentlyOpened)
window.HSDropdown = HSDropdown;

// Import FloatingUI for Preline UI dropdown functionality
// import * as FloatingUIDOM from "@floating-ui/dom";
// window.FloatingUIDOM = FloatingUIDOM;

// Not needed as we override the default Preline helper with custom fix
// import "preline/dist/helper-clipboard.js";

console.debug("Preline clipboard helpers loaded");
